import { Component, ChangeDetectionStrategy } from '@angular/core';
import { SpinnerBarComponent } from '../../library/spinner-bar/spinner-bar.component';
@Component({
  selector: 'widget-loader',
  templateUrl: './widget-loader.component.html',
  styleUrls: ['./widget-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SpinnerBarComponent],
})
export class WidgetLoaderComponent {}
